/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { schedulePropTypes } from 'constants/propTypes';
import Message from 'components/Message';

import { classInfoMessages as messages, reservationsOverviewMessages } from './ScheduleDetail.messages';
import ClassSmartSpotStatus from './ClassSmartSpotToggleContainer';
import './ClassInfoDesktop.scss';

function ClassInfoDesktop({ canToggleClassSmartSpot, canOnlyToggleNonRecurring, schedule }) {
  const {
    duration,
    isDisabled,
    isInThePast,
    resource,
    scheduleClass,
    scheduleName,
    scheduleId,
    smartspotEnabled,
    smartspotEnabledForVenue,
    startDateTime,
  } = schedule;
  const { resourceName: instructorName } = resource || {};
  const { classId } = scheduleClass || {};
  const textClasses = 'text--md text--semibold mb-0';
  const subtextClasses = 'text--sm text--light mt-tiny mb-0';
  const canToggleSmartspot = canToggleClassSmartSpot && !isDisabled;
  const smartSpotMessage = smartspotEnabled ? reservationsOverviewMessages.ss.on : reservationsOverviewMessages.ss.off;

  return (
    <div className="class-info-desktop pv-regular ph-large">
      <div className="class-info-desktop__class-time">
        <p className={classNames(textClasses, { 'class-info-desktop--is-in-the-past': isInThePast })}>
          <Message message={messages.startTime} values={{ startDateTime }} />
        </p>
        <p className={subtextClasses}>
          <Message message={messages.duration} values={{ duration }} />
        </p>
      </div>
      <div className="class-info-desktop__schedule-name mh-regular">
        <p
          className={classNames(textClasses, 'text--ellipsis')}
          title={scheduleName}
          data-cypress="class-info-schedule-name">
          {scheduleName}
        </p>
        <p className={classNames(subtextClasses, 'text--ellipsis')} title={instructorName}>
          {instructorName}
        </p>
      </div>
      {smartspotEnabledForVenue && !isInThePast && (
        <ClassSmartSpotStatus
          className="class-info-desktop__smart-spot-status"
          name={`class-smartspot-desktop-${scheduleId}`}
          isEnabled={smartspotEnabled}
          schedule={schedule}
          showToggle={canToggleSmartspot}
          canOnlyToggleNonRecurring={canOnlyToggleNonRecurring}
          {...{ classId, scheduleId, scheduleName, startDateTime, isDisabled }}>
          <Message message={smartSpotMessage} />
        </ClassSmartSpotStatus>
      )}
    </div>
  );
}

ClassInfoDesktop.propTypes = {
  canToggleClassSmartSpot: PropTypes.bool,
  canOnlyToggleNonRecurring: PropTypes.bool,
  schedule: PropTypes.shape(schedulePropTypes),
};

export default ClassInfoDesktop;
